export default __webpack_public_path__ + "static/media/Inter-VariableFont_slnt,wght.2bc54814.ttf";